import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { CustomGrid } from "../../../../../components/Widget/Widget";
import { GetLearnInstancesWithMetricsByCaptainIdsQuery } from "../../../../../graphql/types";
import {
  LearnMetricsChartProps,
  LearnMetricsChart,
} from "../../../components/LearnMetricsChart";

export interface AvailableUsersWidgetProps
  extends CustomGrid,
    Pick<LearnMetricsChartProps, "showEntitlementLine"> {
  readonly learns: GetLearnInstancesWithMetricsByCaptainIdsQuery["listLearnInstances"]["items"];
  readonly showEntitlements?: boolean;
  readonly stackCharts: boolean;
}

export const BillableUsersWidget: FunctionComponent<
  AvailableUsersWidgetProps
> = ({ learns, showEntitlements, ...props }) => {
  const { t } = useTranslation();

  const metrics = learns.map((l) => ({
    learn: l,
    metrics: l.metrics.users.metrics.map((m) => ({
      date: m.date,
      captainId: l.captainId,
      title: l.url,
      total: m.billableUsers,
      status: l.status,
    })),
  }));

  const today = learns.reduce(
    (a, b) =>
      a +
      b.metrics.users.metrics[b.metrics.users.metrics.length - 1].billableUsers,
    0
  );

  return (
    <LearnMetricsChart
      {...props}
      strings={{
        title: t("learn.metrics.chart.billableUsers.title"),
        titleHelp: t("learn.metrics.chart.billableUsers.help.title"),
        activeEntitlement: t(
          "learn.metrics.chart.billableUsers.help.activeEntitlement"
        ),
        entitlementUtilization: t(
          "learn.metrics.chart.billableUsers.help.entitlementUtilization"
        ),
        peakUtilizationLabel: t(
          "learn.metrics.chart.billableUsers.help.peakUtilizationLabel"
        ),
        peakUtilizationHelp: t(
          "learn.metrics.chart.billableUsers.help.peakUtilizationHelp"
        ),
      }}
      valueFormatString={t(
        "learn.metrics.chart.billableUsers.valueFormatString"
      )}
      valueSuffixString={t("learn.metrics.chart.billableUsers.valueSuffix")}
      data={metrics}
      today={today}
      mix={true}
    />
  );
};
